<template>
  <div class="wxPayWaiting main-container">
       <!-- 手机端显示 -->
    <div class="hidden-md-and-up">
        <div class="box">
          <div class="clock">
            <span class="min" :style="{transform:' rotateZ('+min*12+'deg)'}"></span>
            <span class="sec" :style="{transform:' rotateZ('+sec*6+'deg)'}"></span>
            <span class="dot"></span>
          </div>
          <span style="font-size:.22rem">等待支付中，支付成功后，自动跳转订单详情</span>    
          <p style="padding-top:.3rem;font-size:.3rem;letter-spacing: 0.3em;">还剩<b class="timeNum">{{min}}</b>分<b class="timeNum">{{sec}}</b>秒</p>
        </div>
    </div>
  </div>
</template>

<script>
import { orders_i_url} from '../request/api'
  export default {
    name: "wxPayWaiting",
    data(){
      return{
        ordersDetail:'',
        ordersId:'',
        ordersData:{},
        device: 1,//1pc,2mob设备
        timer:'',
        min:'__',
        sec:'__'
      }
    },
    methods:{
      getordersdata(orderId){
        orders_i_url({id:orderId}).then((res)=>{
            this.ordersData=res.data.data;
              if(this.ordersData.order_status==1){
                this.ordersDetail='待付款'
              }else if(this.ordersData.order_status==2){
                this.ordersDetail='待收货'
                clearInterval(this.timer);
                this.$cookies.set('ordersId', orderId)
                this.$router.push({name:'Orders_i',params:{id:orderId}})
              }else if(this.ordersData.order_status==3){
                this.ordersDetail='已完成'
              }else if(this.ordersData.order_status==4){
                this.ordersDetail='已取消'
              }else if(this.ordersData.order_status==6){
                this.ordersDetail='已退款'
              }
        })
      },
      showTime(){
        const inTime=new Date().getMinutes()
        this.timer = setInterval(()=>{
          this.min=29-(new Date().getMinutes()-inTime)
          this.sec=59-new Date().getSeconds()
          this.getordersdata(this.ordersId)
          if(this.min<1 && this.sec<1){this.$router.push({path:'/Information',query:{id:'orderslist'}})}
        },1000)
      }
    },
    mounted() {
      //设备
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        //移动端
        this.device=2;
      } else {
        //pc端
        this.device=1;
      }

      if (!this.$store.state.isLogin) {
        this.$router.push({path: "/login"});
      }

      // this.ordersId=decodeURIComponent((new RegExp('[?|&]id=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20'))
      this.ordersId=this.$route.query.id?this.$route.query.id:''
      this.showTime()
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<style lang="less" scoped>
.wxPayWaiting{
  .box{
    min-height: 4rem;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  .timeNum{font-size: .7rem;}
  .clock{
    margin: 0 auto;
    width: 2rem;
    height: 2rem;
    background-color: #44b549;
    border-radius: 50%;
    position: relative;
    transform: rotateY(180deg);
    margin-bottom: .3rem;
    span{
      position: absolute;
      background-color: #fff;
      box-shadow: 0.01rem 0.01rem 0.05rem #1d4e20;
      left: 50%;
      top: 50%;
    }
  }
  .min{
    width: .16rem;
    height: .9rem;
    border-radius: 1rem;
    margin-left: -0.08rem;
    margin-top: -0.8rem;
    transform-origin: 0.08rem 0.8rem;
  }
  .sec{
    width: .1rem;
    height: 1.1rem;
    border-radius: 1rem;
    margin-left: -0.05rem;
    margin-top: -.9rem;
    transform-origin: 0.05rem .9rem;
  }
  .dot{
    width: .18rem;
    height: .18rem;
    border-radius: 1rem;
    margin-left: -.09rem;
    margin-top: -.09rem;
  }
}
  
</style>



// WEBPACK FOOTER //
// src/view/wxPayWaiting.vue